import React, { useState, useRef, useEffect } from "react";
import { Links } from "../../help/help";
import Logo from "../../assets/image/logo.png";
import { BsJustify, BsXLg } from "react-icons/bs";

export default function Header() {
  const [menubar, setMenuBar] = useState(false);
  const menuDropdown = useRef(null);

  useEffect(() => {
    function handleClickOutside(event) {
      if (
        menuDropdown.current &&
        !menuDropdown.current.contains(event.target)
      ) {
        setMenuBar(false);
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [menuDropdown]);

  return (
    <div className="absolute top-0 z-20 flex flex-col w-full">
      <div className="container">
        <div className="w-full h-[80px] items-center justify-between flex flex-row px-5 font-barlow">
          <a href="/" className="">
            <p className="px-4 py-2 lg:px-5 text-black uppercase text-[18px] lg:text-[24px] rounded-full justify-center items-center flex flex-col font-sigmar">
              Jorlps Meme
            </p>
          </a>
          <div className="flex flex-row items-center justify-between gap-6 sm2:hidden">
            {menubar ? (
              <div
                ref={menuDropdown}
                className="w-[180px] h-[320px] px-8 py-6 bg-white text-black rounded-bl-xl flex flex-col justify-between absolute top-0 right-0 gap-2 z-20 text-start border-b-[1px] border-b-black border-l-[1px] border-l-black"
              >
                <div
                  onClick={() => setMenuBar(false)}
                  className="flex flex-row justify-end w-full mb-5"
                >
                  <BsXLg />
                </div>
                {Links.map((item, index) => {
                  return (
                    <a key={index} href={item.url} className="w-full">
                      <p className="text-[14px] lg:text-[20px] font-semibold border-b-[1px] border-b-black text-end">
                        {item.name}
                      </p>
                    </a>
                  );
                })}
              </div>
            ) : (
              <div
                onClick={() => setMenuBar(true)}
                className="w-[46px] h-[46px] rounded-full bg-black flex flex-row items-center justify-center text-white text-[24px] cursor-pointer"
              >
                <BsJustify />
              </div>
            )}
          </div>
          <div className="flex-row items-center justify-end hidden gap-2 sm2:flex">
            {Links.map((item, index) => {
              return (
                <a key={index} href={item.url} className="w-[60px] lg:w-[90px]">
                  <p className="text-[12px] lg:text-[18px] font-semibold">
                    {item.name}
                  </p>
                </a>
              );
            })}
          </div>
        </div>
      </div>
    </div>
  );
}
